import { useLocation, useNavigate } from 'react-router-dom';
import { ChartBar, CurrencyDollar, Envelope, ListNumbers, Users, WarningCircle } from '@phosphor-icons/react';
const monoFont = "'IBM Plex Mono', monospace";

const tabs = [
  { path: '/admin', label: 'Home', icon: ChartBar },
  { path: '/admin/usuarios', label: 'Usuários', icon: Users },
  { path: '/admin/convites', label: 'Convites', icon: Envelope },
  { path: '/admin/espera', label: 'Espera', icon: ListNumbers },
  { path: '/admin/financeiro', label: 'Financeiro', icon: CurrencyDollar },
  { path: '/admin/emails', label: 'E-mails', icon: WarningCircle },
];

export function SABottomTabs() {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = (path: string) => {
    if (path === '/admin') return location.pathname === '/admin';
    return location.pathname.startsWith(path);
  };

  // Hide on user profile page
  if (location.pathname.match(/^\/admin\/usuarios\/.+/)) return null;

  return (
    <nav style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 50,
      height: 56,
      backgroundColor: '#0A0A0A',
      borderTop: '0.5px solid rgba(247,246,242,0.12)',
      display: 'flex', alignItems: 'center', justifyContent: 'space-around',
    }}>
      {tabs.map(tab => {
        const active = isActive(tab.path);
        return (
          <button
            key={tab.path}
            onClick={() => navigate(tab.path)}
            style={{
              display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2,
              background: 'none', border: 'none', cursor: 'pointer',
              color: active ? '#00E87A' : 'rgba(247,246,242,0.35)',
              transition: 'color 0.15s ease',
              padding: '6px 12px',
            }}
          >
            <tab.icon size={20} weight="thin" />
            <span style={{ fontFamily: monoFont, fontSize: 12, fontWeight: 300, letterSpacing: '0.02em' }}>
              {tab.label}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
